import React from 'react'

const ManageColumns = ({table}) => {

  return (
    <div className="inline-block border border-black shadow rounded">
      <div className="px-1 border-b border-black">
        <label>
          <input
            {...{
              type: 'checkbox',
              checked: table.getIsAllColumnsVisible(),
              onChange: table.getToggleAllColumnsVisibilityHandler(),
            }}
          />{' '}
          Toggle All
        </label>
      </div>
      
      {table.getAllLeafColumns().map((column, index) => {
        if( index === 0 ) return false 
        return (
          <div key={column.id} className="px-1">
            <label>
              <input
                {...{
                  type: 'checkbox',
                  checked: column.getIsVisible(),
                  onChange: column.getToggleVisibilityHandler(),
                }}
              />{' '}
              {column.columnDef.prettyName}
            </label>
          </div>
        )
      })}
    </div> 
  )
}

export default ManageColumns